import React, { useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

/**
 * Redirects legacy customer deep-links (query-param based) to the new universal
 * /menu/:restaurantId/* routes.
 */
export default function LegacyToUniversalRedirect({ target = 'landing' }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const restaurantId = searchParams.get('restaurantId');

    // If no restaurantId, keep legacy behavior by going to the old route.
    if (!restaurantId) return;

    if (target === 'landing') {
      navigate(`/menu/${encodeURIComponent(restaurantId)}`, { replace: true });
      return;
    }

    if (target === 'cart') {
      navigate(`/menu/${encodeURIComponent(restaurantId)}/cart`, { replace: true });
      return;
    }

    // Fallback: send to universal landing
    navigate(`/menu/${encodeURIComponent(restaurantId)}`, { replace: true });
  }, [navigate, location.key, searchParams, target]);

  return null;
}
